import { useState, useEffect, useMemo } from "react";
import { subscribeWorkspace, toSortedArray } from "../services/workspaceService";
import { readingTabFor, isQueueVisible } from "../config/readingStates";

export function flattenArticles(data) {
  const all = [];
  for (const desk of data?.desks || []) {
    for (const drawer of toSortedArray(desk.drawers)) {
      for (const notebook of toSortedArray(drawer.notebooks)) {
        for (const text of toSortedArray(notebook.texts)) {
          all.push({
            ...text,
            deskId: desk.id,
            drawerId: drawer.id,
            notebookId: notebook.id,
            deskName: desk.name,
            deskSlug: desk.slug,
            drawerName: drawer.name,
            drawerSlug: drawer.slug,
            notebookName: notebook.name,
            notebookSlug: notebook.slug,
          });
        }
      }
    }
  }
  return all;
}

export function useReadingArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribeWorkspace((data) => {
      setArticles(flattenArticles(data));
      setLoading(false);
    });
    return unsub;
  }, []);

  const counts = useMemo(() => {
    const c = { unread: 0, later: 0, review: 0, read: 0, archived: 0, trash: 0 };
    articles.forEach((a) => {
      const t = readingTabFor(a);
      if (c[t] != null) c[t] += 1;
    });
    return c;
  }, [articles]);

  const unread = useMemo(
    () =>
      articles
        .filter((a) => readingTabFor(a) === "unread")
        .sort((a, b) => (a.updatedAt || 0) - (b.updatedAt || 0)),
    [articles]
  );

  const catchUpQueue = useMemo(
    () =>
      articles
        .filter((a) => isQueueVisible(a) && readingTabFor(a) !== "read")
        .sort((a, b) => {
          const tabOrder = { unread: 0, review: 1, later: 2 };
          const ta = tabOrder[readingTabFor(a)] ?? 9;
          const tb = tabOrder[readingTabFor(b)] ?? 9;
          if (ta !== tb) return ta - tb;
          return (a.updatedAt || 0) - (b.updatedAt || 0);
        }),
    [articles]
  );

  return { articles, loading, counts, unread, catchUpQueue };
}
